import React, {useContext, useEffect, useState} from "react";
import {
    Icon,
    Dropdown,
} from "semantic-ui-react";
import { Col, Row, Empty, Divider, Table, Button } from 'antd';
import { LeftOutlined, LoadingOutlined, RightOutlined, SearchOutlined } from "@ant-design/icons";

import axios from "axios";
import ModalVerJurados1 from "../../../../components/Jurados/Modal/index";
import { ModalExportarDatosJurado } from "../../../../components/Jurados/ExportarDatosJurado";
import FiltroPalabra from '../FiltrosComponent/filtroPalabra'
import { IModalProps } from "../../../../components/Jurados/InterfaceProp";
import {TemplateContext} from "../../../../utils/template_context";
import { ReactComponent as IconFlechareg } from "../../../../assets/flecha_reg.svg";



const TablaDePostulados = ({setJurados, Tabla, userPermissions, inputFilter, filterByMany, primeroDatostabla, enableObservation }: any) => {
    const context = useContext(TemplateContext);
    const [cantidadPaginas, setCantidadPaginas] = React.useState(10);
    const changeValue = (e: any, { value }: any) => {
        console.log(e, value)
        setCantidadPaginas(value)
    }
    const [clickTab, setClickTab] = useState(false);

    const handleClickTab = () => {
        setClickTab(true);
    }

    function itemRenderTable(current: any, type: any, originalElement: any) {
        if (type === "prev") {
            return (
                <span className="border-ant-prev-table font-size-10px">
                    <LeftOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingRight: "2px" }} />
                    Ant.
                </span>
            );
        }
        if (type === "next") {
            return (
                <span className="border-ant-prev-table font-size-10px">
                    Sig.
                    <RightOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingLeft: "2px" }} />
                </span>
            );
        }
        return originalElement;
    }

    const arrayPostulados = Tabla.filter((data: any) => {
        return data.status === 'Aceptó' || data.status === 'No aceptó' || data.status === 'Postulado'  || data.status === 'No responde'
    });

    const cantidadRegistros = [
        {
            key: 1,
            value: 10,
            text: "10",
        },
        {
            key: 2,
            value: 20,
            text: "20",
        },
        { key: 3, value: 50, text: "50" },
        { key: 4, value: 100, text: "100" },
    ];
    const columns: any = [
        {
            title: "No.",
            width: 40,
            render: (datos: any, datos2: any, index: number) => {
                return (
                    <>
                        <span>{++index}</span>
                    </>
                );
            },
            fixed: context.device === "md"? "left": false,
        },
        {
            title: "Nombre y apellido",
            width: 300,
            render: (datos: any) => {
                return (
                    <>
                        {datos.primer_nombre}{" "} {datos.segundo_nombre}{" "}
                        {datos.primer_apellido}{" "} {datos.segundo_apellido}
                    </>
                );
            },

        },
        {
            title: "Nro documento",
            width: 140,
            dataIndex: "numero_documento",
            key: "numero_documento",
        },
        {
            title: "Código",
            width: 120,
            render: (datos: any) => {
                return (
                    <>
                        {datos.id_jurado}
                    </>
                );
            },
        },
        {
            title: "Estado",
            width: 120,
            render: (datos: any) => {
                return (
                    <>
                        {datos.status}
                    </>
                );
            },
        },
        {
            title: "Lineas",
            width: 469,
            render: (datos: any) => {              
                return (
                    <>
                        {datos.lineas.map((datos_lineas: any, index: number)=>
                        {
                            return <span key={index} style={{fontFamily:'Work-Sans-Regular'}}> {datos_lineas?.line} / </span>
                        }
                        )}
                    </>         
                );
            },
        },
        {
            title: "Categoría",
            width: 469,
            render: (datos: any) => {
                return (
                    <>
                        {datos.lineas.map((datos_lineas: any)=>
                            datos_lineas.categories.map((datos_categorias: any, index: number)=>  
                                (  
                                    <span key={index} style={{fontFamily:'Work-Sans-Regular'}}> {datos_categorias?.category} / </span>
                                )
                            )
                        )}
                    </>
                );
            },
        },
        {
            title: () => (
                <Row className="width-100">
                    <Col span={24} className="justify-content-center">
                        Acciones
                    </Col>
                </Row>
            ),
            width: 90,
            fixed: context.device === "lg"? "right": false,
            render: (datos: any) => (
                <>
                    <Row className="width-100">
                        <Col span={24} className="justify-content-center">
                            <ModalVerJurados1 setJurados={setJurados} primeroDatostabla={primeroDatostabla} enableObservation={enableObservation} handleObservacion={null} observacionData={null} changeState={null} buttonPostulation={null} datos={datos} userState={userPermissions} handleClickTab={handleClickTab} />
                        </Col>
                    </Row>
                </>
            ),
        },
    ];

    // console.log(arrayPostulados)
    return (
        <div className="h-100">
            <div className="container-fluid ps-md-4 pe-md-4 main-c7">
                <Row className="row-shadow mt-3 mb-3" >
                    <Row className="width-100" style={{ paddingLeft: "2%", paddingRight: "2%" }}>
                        <FiltroPalabra filterByMany={filterByMany} inputFilter={inputFilter} primeroDatostabla={primeroDatostabla} />
                        <Divider style={{ marginBottom: "16px", marginTop: "10px" }} />
                        <Row className="width-100">
                            <Col span={19} className="font-size-14px font-family-Montserrat-SemiBold" style={{ paddingBottom: "0%" }}>
                                Gestionar postulación de jurados
                            </Col>
                            <Col span={2} className="justify-content-center">
                                {/* Total : <span className="font-color-F28C02">{totalregistros}</span> */}
                            </Col>
                            <Col span={3} style={{ display: "flex", flexDirection: "row" }}>
                            <span style={{ flex: 0.7 }} className="font-family-Montserrat-Regular font-size-9px font-color-7E7E7E">
                                Registros por página
                            </span>
                                <Dropdown
                                    fluid
                                    style={{ flex: 0.3 }}
                                    className="select-registros-adminconvocatoria no-margin"
                                    defaultValue={cantidadPaginas}
                                    options={cantidadRegistros}
                                    icon={<IconFlechareg/>
                    }
                                    // onChange={(e, { value }) => setCantidadPáginas(e, value)}
                                    onChange={changeValue}
                                />
                            </Col>
                        </Row>
                        <Row className="width-100">
                            <Col span={24}
                            >
                                <Table
                                    locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                                    pagination={{ position: ["bottomRight"], itemRender: itemRenderTable,/*  pageSize: cantidadPáginas */ }}
                                    dataSource={arrayPostulados}
                                    columns={columns}
                                    size="small"
                                    className="tab-pane-jurados"
                                    bordered={false}
                                    scroll={{ x: 1600 }}
                                />
                            </Col>
                        </Row>
                    </Row>
                </Row>
                <div style={{ width: '100%' }}>
                    <Row className="container-sticky-footer" style={{ padding: 10 }}>
                        <Col span={12}>
                            {/* <Button className="button-blanco-radius">ATRÁS</Button> */}
                        </Col>
                        <Col span={12} className="justify-content-flex-end">
                            {userPermissions && (
                                <ModalExportarDatosJurado />
                            )}
                        </Col>
                    </Row>
                </div>
            </div>
        </div>

    );
}
export default TablaDePostulados